import { createTheme } from "react-data-table-component";

/** The shared react-data-table-component theme used by the admin tables (users, requests). */
export const adminTableTheme = createTheme("rws-admin-users", {
  text: {
    primary: "var(--color-text-primary)",
    secondary: "var(--color-text-secondary)",
    disabled: "var(--color-text-secondary)",
  },
  background: {
    // Opaque, so the page background never shows through the rows; the header is washed with the header's light (--color-link).
    default: "var(--panel-solid)",
    header: "color-mix(in srgb, var(--color-link) 8%, var(--panel-solid))",
    footer: "var(--panel-solid)",
  },
  context: {
    background: "var(--color-accent-primary)",
    text: "var(--color-accent-primary-text)",
  },
  divider: { default: "color-mix(in srgb, var(--color-border-default) 70%, transparent)" },
  button: {
    default: "var(--color-text-primary)",
    focus: "var(--color-accent-primary)",
    hover: "color-mix(in srgb, var(--color-link) 14%, transparent)",
    disabled: "var(--color-text-secondary)",
  },
  selected: {
    default: "color-mix(in srgb, var(--color-link) 14%, var(--panel-solid))",
    text: "var(--color-text-primary)",
  },
  highlightOnHover: {
    default: "color-mix(in srgb, var(--color-link) 9%, var(--panel-solid))",
    text: "var(--color-text-primary)",
  },
  striped: {
    default: "color-mix(in srgb, var(--color-link) 3%, var(--panel-solid))",
    text: "var(--color-text-primary)",
  },
  spacing: {
    rowHeight: "3.5rem",
    headerHeight: "3.5rem",
    cellPaddingX: "1rem",
    iconSize: "1.125rem",
  },
  typography: {
    fontSize: "var(--font-size-body)",
    fontSizeHeader: "var(--font-size-small)",
    fontFamily: "var(--font-family-base)",
  },
  shape: { borderRadius: "var(--radius-medium)" },
});
